import { AxiosRequestConfig } from 'axios';
import api from './api';
import { EducationResponsePaginated, EducationResponse, Education, EducationRequest } from '../@types/educationTypes';
import { mapInformationChartDataObject } from '../@types/chartData';

const educationUrl = '/api/edu_records/';

function getEducations(config: AxiosRequestConfig) {
	return api.get<EducationResponsePaginated>(educationUrl, config);
}

function getEducationById(id: string) {
	return api.get<EducationResponse>(`${educationUrl}${id}/`);
}

async function deleteEducationById(id: string) {
	return api.delete(`${educationUrl}${id}/`);
}

function createEducation(educationData: EducationRequest) {
    return api.post<EducationResponse | string>(educationUrl, educationData);
}

function updateEducation(id: string, updatedEducationData: EducationRequest) {
	return api.put<EducationResponse>(`${educationUrl}${id}/`, updatedEducationData);
}

function getEducationInformationChartData(config: AxiosRequestConfig) {
	return api.get<mapInformationChartDataObject[]>(`${educationUrl}map_side_list/`, config);
}

const educationServices = {
	getEducations,
	getEducationById,
	deleteEducationById,
	createEducation,
	updateEducation,
	getEducationInformationChartData
};

export default educationServices;